// Category-based thumbnail images with variety
export const categoryThumbnails = {
  'GenAI': [
    'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1655720031554-a929595ffad7?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1676573409804-4c08f4b27e7f?w=800&h=450&fit=crop'
  ],
  'AI Strategy': [
    'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800&h=450&fit=crop'
  ],
  'Data Science': [
    'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800&h=450&fit=crop'
  ],
  'Data Visualization': [
    'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1543286386-713bdd548da4?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800&h=450&fit=crop'
  ],
  'Decision Science': [
    'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=800&h=450&fit=crop'
  ],
  'Emerging Tech': [
    'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=450&fit=crop'
  ],
  'FinTech': [
    'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1565514158740-64ba4b6c4d5d?w=800&h=450&fit=crop'
  ],
  'Healthcare & Science': [
    'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1579154204601-01588f351e67?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=800&h=450&fit=crop'
  ],
  'No Code AI': [
    'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1542831371-29b0f74f9713?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=800&h=450&fit=crop'
  ],
  'Nutrition': [
    'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=800&h=450&fit=crop'
  ],
  'Predictive Analytics': [
    'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1543286386-713bdd548da4?w=800&h=450&fit=crop'
  ],
  'default': [
    'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&h=450&fit=crop',
    'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&h=450&fit=crop'
  ]
};

// Default placeholder image
const defaultPlaceholder = 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=450&fit=crop';

/**
 * Get a unique thumbnail for a webinar
 * If the thumbnail is the default placeholder, return a category-specific image
 */
export const getWebinarThumbnail = (webinar) => {
  const thumbnail = webinar?.thumbnail || '';
  
  // If thumbnail is empty or is the default placeholder, use category-based image
  if (!thumbnail || thumbnail.includes('photo-1677442136019-21780ecad995')) {
    const category = webinar?.category || 'default';
    const categoryImages = categoryThumbnails[category] || categoryThumbnails['default'];
    
    // Use webinar_id to deterministically pick an image from the category array
    const webinarId = webinar?.webinar_id || '';
    const hash = webinarId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    const imageIndex = hash % categoryImages.length;
    
    return categoryImages[imageIndex];
  }
  
  return thumbnail;
};

/**
 * Get thumbnail with error fallback
 */
export const getThumbnailWithFallback = (webinar, onError) => {
  const thumbnail = getWebinarThumbnail(webinar);
  
  return {
    src: thumbnail,
    onError: (e) => {
      // If image fails to load, use default
      e.target.src = defaultPlaceholder;
      if (onError) onError(e);
    }
  };
};
